"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiCardContent = exports.MuiCardActions = exports.MuiCard = void 0;
exports.MuiCard = {
    styleOverrides: {
        root: {
            boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.17), 0px 1px 3px rgba(0, 0, 0, 0.2)',
        },
    },
};
exports.MuiCardActions = {
    styleOverrides: {
        root: {
            padding: '8px 16px 16px 16px',
        },
    },
};
exports.MuiCardContent = {
    styleOverrides: {
        root: {
            '&:last-child': {
                paddingBottom: 16,
            },
        },
    },
};
//# sourceMappingURL=MuiCard.js.map